"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAnswerPathTreeFromBlueprint = void 0;
const validations_1 = require("../validations");
const makeAnswerPathTreeFromBlueprint = (blueprint) => {
    return createSectionGroupNodes(blueprint);
};
exports.makeAnswerPathTreeFromBlueprint = makeAnswerPathTreeFromBlueprint;
const isRepeatable = (data) => {
    return 'repeatable' in data;
};
const isRepeatableSectionGroup = (sectionGroup) => isRepeatable(sectionGroup);
const isRepeatableFieldGroup = (fieldGroup) => isRepeatable(fieldGroup);
function createSectionGroupNodes(blueprint) {
    const sectionGroupNodes = [];
    Object.keys(blueprint.sectionGroupBlueprints).forEach((sectionGroupKey) => {
        const sectionGroupBlueprint = blueprint.sectionGroupBlueprints[sectionGroupKey];
        if (!sectionGroupBlueprint || !(0, validations_1.isSectionGroupBlueprint)(sectionGroupBlueprint)) {
            return;
        }
        const sections = blueprint.sectionBlueprints
            .filter((sectionBlueprint) => sectionBlueprint.sectionGroupKey === sectionGroupKey)
            .map(createSectionNode);
        if (isRepeatableSectionGroup(sectionGroupBlueprint)) {
            sectionGroupNodes.push({
                nodeId: sectionGroupBlueprint.id,
                path: sectionGroupBlueprint.id,
                isCollection: true,
                children: sections,
            });
        }
        else {
            sectionGroupNodes.push({
                nodeId: sectionGroupBlueprint.id,
                path: sectionGroupBlueprint.id,
                children: sections,
            });
        }
    });
    return sectionGroupNodes;
}
function createSectionNode(sectionBlueprint) {
    const subsections = sectionBlueprint.subsections.map(createSubsectionNode);
    return {
        nodeId: sectionBlueprint.id,
        path: sectionBlueprint.id,
        children: subsections,
    };
}
function createSubsectionNode(subsectionBlueprint) {
    const fieldGroups = subsectionBlueprint.fieldGroups.map(createFieldGroupNode);
    return {
        nodeId: subsectionBlueprint.id,
        path: subsectionBlueprint.id,
        children: fieldGroups,
    };
}
function createFieldGroupNode(fieldGroupBlueprint) {
    const fields = fieldGroupBlueprint.fields.map(createFieldNode);
    if (isRepeatableFieldGroup(fieldGroupBlueprint)) {
        return {
            nodeId: fieldGroupBlueprint.id,
            path: fieldGroupBlueprint.id,
            isCollection: true,
            children: fields,
        };
    }
    return {
        nodeId: fieldGroupBlueprint.id,
        path: fieldGroupBlueprint.id,
        children: fields,
    };
}
function createFieldNode(fieldBlueprint) {
    return {
        nodeId: fieldBlueprint.id,
        path: fieldBlueprint.id,
    };
}
